module.exports = __webpack_public_path__ + "img/mgh-fukuoka-nakasu@2x.5404d856.jpg";